import React from 'react';
import { Divider, Hr, Subtitle } from '@/components/atoms';
import { InfoWrapper } from './InfoListItem.styled';

import { rem } from '@/styles/theme';

interface IProps {
  title: string;
  content: string;
  isDivider?: boolean;
  isBottomLine?: boolean;
}

const InfoListItem = (props: IProps) => {
  const { title, content, isDivider = false, isBottomLine = true } = props;

  return (
    <div>
      {isDivider && <Divider />}
      <InfoWrapper isDivider={isDivider}>
        <dt>
          <Subtitle level={5} color="gray-800">
            {title}
          </Subtitle>
        </dt>
        <dd>
          <Subtitle level={6} color="gray-700" whiteSpaceWrap>
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
          </Subtitle>
          {isBottomLine && <Hr style={{ marginTop: `${rem(24)}` }} />}
        </dd>
      </InfoWrapper>
    </div>
  );
};

export default InfoListItem;
